import { GameReelWildParticleProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameReelWildParticlesProperties";
export class ReelWildParticlesLandscapeProperties extends GameReelWildParticleProperties {
    constructor() {
        super();
        this.position.set(608, 98);
    }
}
//# sourceMappingURL=ReelWildParticlesLandscapeProperties.js.map